<script>
import BaseGrid from '@/views/finance/incomes/BaseGrid';

export default {
    name: 'CashGrid',
    extends: BaseGrid,
    data() {
        return {
            headerOptions: {
                isNewButtonVisible: true
            },
            settingName: 'incomes-cash',
            title: 'Список наличных приходов',
            isPayTypeFilterVisible: false
        };
    },
    beforeMount() {
        this.filterModel.pay_type_id = this.cashPayTypes;
    },
    computed: {
        isIncomeCashEmployer() {
            return this.$store.getters.isIncomeCashEmployer;
        },
        isIncomeCashDirector() {
            return this.$store.getters.isIncomeCashDirector;
        },
        canCreateIncome() {
            return (this.isIncomeCashDirector || this.isIncomeCashEmployer);
        }
    },
    methods: {
        onSelectionChanged(e) {
            this.$router.push({ name: 'income-cash-card-view', params: { id: '' + e.node.data.id } });
        },
        goNewCard() {
            this.$router.push({ name: 'income-cash-card', params: { id: 'new' } });
        }
    }
};
</script>
